export const CARE_STATE_PROBLEM_HISTORY_TAB_ID = 'care-state:problemHistory';

export { ProblemHistoryTab, ProblemListCard } from './ui';
export type { ProblemHistoryTabProps, ProblemListCardProps } from './ui';
